export type Theme = "light" | "dark";

const THEME_KEY = "cost-analyzer:theme:v1";

export function normalizeTheme(x: unknown): Theme | null {
  if (x === "light" || x === "dark") return x;
  return null;
}

export function readStoredTheme(): Theme | null {
  try {
    return normalizeTheme(localStorage.getItem(THEME_KEY));
  } catch {
    return null;
  }
}

export function writeStoredTheme(theme: Theme): void {
  try {
    localStorage.setItem(THEME_KEY, theme);
  } catch {
    /* ignore */
  }
}
